import Module from '../lib/module';
import Util, { ViewPort } from '../lib/util';
import Inputmask from 'inputmask';

@Module.define('common')
class Common extends Module {
	constructor(options) {
		super(options);

		this.accountNavList = $('.js-account-nav-list');
		this.accountNavSelect = $('.js-account-nav-select');
		this.isAccountSaveStuck = false;

		this.filters = $('.filter');
		this.formProceedInput = $('.js-form-proceed-input');
		this.formProceedSubmit = $('.js-form-proceed-submit');
		this.claimID = window.claimID;

		this.mobileNavToggle = $('.js-nav-toggle');
        this.header = $('#header');
        this.headerWrap = $('.header-wrap');
		this.body = $('body');
		this.mobileAccountMenu = $('.mobile-account-menu');
        this.nav = $('.nav');
        this.impersonationBanner = $('.impersonate-banner');
		this.mobileNavToggleElements = $('#header, body, .mobile-account-menu, .nav');

		this.menuToggle = $('.js-menu-dropdown-toggle');
		this.menuOpenSelector = '.js-menu-dropdown-toggle.menu-open';

		this.searchInput = $('.js-search-input');

		this.filterToggle = $('.js-filter-toggle');
		this.filter = $('.filter');

		//this.favoriteButton = $('.js-favorite-button');

		this.phoneMaskInput = $('.js-phone-mask');
		this.accountForm = $('#accountForm');

		this.phoneMask = new Inputmask({
			alias: 'abstractphone',
			rightAlign: false
		});
	}


	main() {
		const _this = this
	}


	bindEvents() {
		// Mobile Menu
		this.mobileNavToggle.on('click touch', e => { this.mobileMenu() });
		// Dropdown open/close on click
		this.menuToggle.on('click touch', e => { this.dropdown(e) });

		// Dropdown close on focus of search input or another menu
		this.menuToggle.on('focus', e => { this.dropdownClose(this.menuOpenSelector) });
		this.searchInput.on('focus', e => { this.dropdownClose(this.menuOpenSelector) });

		// Dropdown close on click away
		$('body').on('click touch', e => { this.dropdownClose(this.menuOpenSelector) });

		// Smoothly scroll all anchors
		$('a[href*="#"]:not([href="#"])').on('click touch', e => { this.smoothScrollAnchors(e) });

		// Toggle Product Detail Favorite
		//this.favoriteButton.on('click touch', e => { this.favoriteToggle(e) });
		//this.favoriteButton.on('keypress', e => {
		//	if (e.keyCode === 13) {
		//		this.favoriteToggle(e);
		//	}

		//});

		// Toggle Mobile Account Nav
		this.accountNavSelect.on('click touch', e => { this.accountNavToggle(e) });

		// Stick Account Save Button
        $(window).on('scroll', e => { this.accountStickSave(); this.stickImpersonation(); });

		// Masks
		//this.phoneMask.mask(this.phoneMaskInput);

		$(window).on('resize', Util.debounce(e => this.onResize(e)));
	}


	onResize(e) {
		if (Util.getViewPort() === ViewPort.Desktop) {
			this.mobileNavToggleElements.removeClass('mobile-menu-open');
			this.nav.removeAttr('style');
		}
	}


	// Custom Functions
	accountNavToggle(e) {
		let $selectIcon = $(e.currentTarget).find('.icon');

		this.accountNavList.slideToggle().toggleClass('open');
		$selectIcon.toggleClass('icon-angle-down icon-angle-up');
    }


	accountStickSave() {
		if ($('.account-save').length) {
			let isStuck = false;
			let $stickyElem = $('.account-save');
			let $parent = $('.form-container');
			let parentOffset = Math.round($parent.offset().top);
			let parentHeight = $parent.outerHeight();
			let stickyHeight = $stickyElem.outerHeight();
			let viewHeight = $(window).height();
			let totalHeight = parentHeight;


			let offset = parentOffset + totalHeight - $(window).scrollTop();

			if ((offset <= viewHeight) && !this.isAccountSaveStuck) {
				this.isAccountSaveStuck = true;
				$stickyElem.removeClass('fixed');
			}
			if ((offset > viewHeight) && this.isAccountSaveStuck) {
				this.isAccountSaveStuck = false;
				$stickyElem.addClass('fixed');
			}
		}


	}

	dropdown(e) {
		let $target = $(e.currentTarget);
		let openMenu = this.menuOpenSelector;

		if ($target.hasClass('menu-open')) {
			this.dropdownClose(openMenu);
		}
		else {
			this.dropdownClose(openMenu);
			this.dropdownOpen($target);
		}
		e.stopPropagation();
	}

	dropdownClose(target) {
		$(target).next('.menu-dropdown-menu').slideUp('fast');
		$(target).removeClass('menu-open');
	}

	dropdownOpen(target) {
		target.next('.menu-dropdown-menu').slideDown('fast');
		target.addClass('menu-open');
	}

	//favoriteToggle(e) {
	//	let $this = $(e.currentTarget);
	//	$this.toggleClass('icon-favorite-empty icon-favorite favorited not-favorited');
	//}

	mobileMenu() {
		let openClass = 'mobile-menu-open';
		let $nav = this.nav;
		let $header = this.header;
		let $acctMenu = this.mobileAccountMenu;

		if ($nav.hasClass(openClass)) {
			this.body.removeClass(openClass);
			$nav.slideUp('fast', e => {
				$nav.removeClass(openClass);
				$acctMenu.removeClass(openClass);
				$header.removeClass(openClass);
			})
		}
		else {
			$nav.addClass(openClass);
			$acctMenu.addClass(openClass);
			$header.addClass(openClass);

			$nav.slideDown('fast', e => {
				this.body.addClass(openClass);
			})
		}
	}

	stickFilterActions() {
		let offset = this.filterOffset + this.filterHeight + this.stickyHeight - $(window).scrollTop();

		if ((offset <= this.viewHeight) && !this.stickyElem.hasClass('static')) {
			this.stickyElem.addClass('static');
		}
		if ((offset > this.viewHeight) && this.stickyElem.hasClass('static')) {
			this.stickyElem.removeClass('static');
		}
    }


    stickImpersonation() {
        let offset = this.headerWrap[0].offsetHeight;
        let bannerHeight = this.impersonationBanner[0] && this.impersonationBanner[0].offsetHeight;

        if (offset <= window.pageYOffset && !this.impersonationBanner.hasClass('sticky')) {
            this.impersonationBanner.addClass('sticky');
            $('#wrapper').css('padding-top', bannerHeight + 'px');
        }
        if (offset > window.pageYOffset && this.impersonationBanner.hasClass('sticky')) {
            this.impersonationBanner.removeClass('sticky');
            $('#wrapper').css('padding-top', '0');
        }
    }


	smoothScrollAnchors(e) {
		let targetAnchor = e.currentTarget;

		if (location.pathname.replace(/^\//, '') === targetAnchor.pathname.replace(/^\//, '') && location.hostname === targetAnchor.hostname) {
			var target = $(targetAnchor.hash);
			target = target.length ? target : $('[name=' + targetAnchor.hash.slice(1) + ']');
			if (target.length) {
				var topOffset = target.offset().top;
				var finalOffset = topOffset - 150;

				$('html, body').animate({
					scrollTop: finalOffset
				}, 750);
				return false;
			}
		}
	}
}